import '..//..//..//mixins.js'
import spinner from "../../LoadingComponent/LoadingComponent.vue"
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'diversification',
  components: {spinner},
  data() {
    return {
      responseData : null,
      showSpinner: false,
      regionWeights: null,
      diversification: [],
      portfolio_id : this.$route.params.PORTFOLIO_ID,
      PortfolioEmpty : false
    }
  },
  created(){

  },
  beforeMount () {

  },
  mounted () {
    this.loadData();
    window.addEventListener("resize", this.myEventHandler);

  }, 
  computed: {
    ...mapState(['PD_userData']),
    ...mapGetters(['get_PD_userData']),
  },
  watch: {
    PD_userData: async function(){
      this.myEventHandler();
  }
},
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    ...mapActions(['load_PD_userWeights']),
    myEventHandler() {
      var activeTab;
      activeTab = this.getActiveTab("nav-bar-diversification");
      this.accessDiversificationByKey(activeTab, 'diversification');
    },

    loadData: async function() {

      console.log(this.get_PD_userData['diversification'])
      this.accessDiversificationByKey('security', 'diversification');
    },
    accessDiversificationByKey: function(key, divName){
      if (typeof(this.get_PD_userData['diversification']) == 'undefined' || Object.keys(this.get_PD_userData['diversification']).length === 0){
        this.PortfolioEmpty = true;
      }
      else{
        
        var requestedDiversificationData = this.get_PD_userData['diversification'][key];
        this.plotPieChart(requestedDiversificationData, divName);
        this.buttonActivation("nav-bar-diversification", "btn");
      }
    }
  }
}